import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CustomDataService {

  videoSrc:string = "" ; 
  videoDisplay:boolean = false  ;
  tweets = [
    {
      title:"GuTemplate &#8211; Pro Templates Library for WordPress | AA-Team ",
      url:"https://t.co/Im0M0X2K2E" , 
      date:'May 16, 2019 11:41 am'
  },
  {
    title:"Check out 'GuTemplate - Pro Templates Library for WordPress' on #EnvatoMarket ",
    url:"https://t.co/tM05ozsrUk",
    date:"April 10, 2019 9:09 am"
  }
  ]
  tags:any[]=[
    'HOT STUFF',
    "WHAT'S NEXT" ,
    'AWARDS' , 
    'TRENDING' , 
    'BLOCKBUSTERS' , 
    'REVIEWS' 
  ]
  types :any[] = [
    "ACTION",
    "ADVENTURE",
   "ANIMATION" , 
    "DRAMA",
    "THRILLER" , 
    "COMEDY" , 
    "MINDRAMA",
    "MYSTERY",
    "THRILLER" , 
    "FANTASY"
  ]

  Day1:any[]=[
    {
      movieId:4 , 
      type:"6D", 
      Magnum:[] , 
      Private  : ["11:30 am","2:30 pm","2:30 pm","10:00 pm"] , 
      VIP :  ["11:30 am" , "7:00 pm","8:30 pm","11:30 pm"]

   } , 
   {
    movieId:1 , 
    type:"2D", 
    Magnum:["11:30 am" , "7:00 pm","8:30 pm","11:30 pm"] , 
    Private  : ["2:30 pm","10:00 pm"] , 
    VIP :  ["1:00 pm" , "7:00 pm"]

 } , 
 {
  movieId:6 , 
  type:"IMAX", 
  Magnum:["11:30 am" , "1:00 pm","2:30 pm","5:30 pm"] , 
  Private  : ["2:30 pm","10:00 pm"] , 
  VIP :  ["11:30 am" ,"1:00 pm" ,"10:00 pm"]

} 
]

Day2:any[]=[
  {
    movieId:8 , 
    type:"6D", 
    Magnum:[] , 
    Private  : ["11:30 am","2:30 pm","2:30 pm","10:00 pm"] , 
    VIP :  ["11:30 am" , "7:00 pm","8:30 pm","11:30 pm"]

 } , 
 {
  movieId:5 , 
  type:"2D", 
 
  Magnum:["11:30 am" , "1:00 pm","2:30 pm","5:30 pm"] , 
Private  : ["2:30 pm","10:00 pm"] , 
VIP :  ["11:30 am" ,"1:00 pm" ,"10:00 pm"]

} , 
{
movieId:3 , 
type:"IMAX", 
Magnum:["11:30 am" , "7:00 pm","8:30 pm","11:30 pm"] , 
Private  : ["2:30 pm","10:00 pm"] , 
VIP :  ["1:00 pm" , "7:00 pm"]


} 
]

Day3:any[]=[
  {
    movieId:7, 
    type:"6D", 
    Magnum:["11:30 am" , "1:00 pm","2:30 pm","5:30 pm"] , 
    Private  : ["2:30 pm","10:00 pm"] , 
    VIP :  ["11:30 am" ,"1:00 pm" ,"10:00 pm"] 
  

 } , 
 {
  movieId:3 , 
  type:"2D", 
  Magnum:["11:30 am" , "7:00 pm","8:30 pm","11:30 pm"] , 
  Private  : ["2:30 pm","10:00 pm"] , 
  VIP :  ["1:00 pm" , "7:00 pm"]

} , 
{
movieId:1, 
type:"IMAX", 
Private  : ["11:30 am","2:30 pm","2:30 pm","10:00 pm"] , 
VIP :  ["11:30 am" , "7:00 pm","8:30 pm","11:30 pm"] , 
Magnum:[] 

},
{
  movieId:6, 
  type:"6D", 
  Magnum:["11:30 am" , "1:00 pm","2:30 pm","5:30 pm"] , 
  Private  : ["2:30 pm","10:00 pm"] , 
  VIP :  ["11:30 am" ,"1:00 pm" ,"10:00 pm"] 


} 
]


Day4:any[]=[
  {
    movieId:4 , 
    type:"IMAX", 
    Magnum:[] , 
    Private  : ["11:30 am","2:30 pm","2:30 pm","10:00 pm"] , 
    VIP :  ["11:30 am" , "7:00 pm","8:30 pm","11:30 pm"]

 } , 
 {
  movieId:8 , 
  type:"2D", 
 
  Magnum:["11:30 am" , "1:00 pm","2:30 pm","5:30 pm"] , 
Private  : ["2:30 pm","10:00 pm"] , 
VIP :  ["11:30 am" ,"1:00 pm" ,"10:00 pm"]

} , 
{
movieId:7 , 
type:"9D", 
Magnum:["11:30 am" , "7:00 pm","8:30 pm","11:30 pm"] , 
Private  : ["2:30 pm","10:00 pm"] , 
VIP :  ["1:00 pm" , "7:00 pm"]


} 
]

Day5:any[]=[
  {
    movieId:5 , 
    type:"6D", 
    Magnum:["11:30 am" , "1:00 pm","2:30 pm","5:30 pm"] , 
    Private  : ["2:30 pm","10:00 pm"] , 
    VIP :  ["11:30 am" ,"1:00 pm" ,"10:00 pm"]
    
 } , 
 {
  movieId:3 , 
  type:"2D", 
  Magnum:[] , 
  Private  : ["11:30 am","2:30 pm","2:30 pm","10:00 pm"] , 
  VIP :  ["11:30 am" , "7:00 pm","8:30 pm","11:30 pm"]


} , 
{
movieId:4 , 
type:"IMAX", 
Magnum:["11:30 am" , "7:00 pm","8:30 pm","11:30 pm"] , 
Private  : ["2:30 pm","10:00 pm"] , 
VIP :  ["1:00 pm" , "7:00 pm"]


} 
]

Day6:any[]=[
  {
    movieId:8 , 
    type:"6D", 
    Magnum:["11:30 am" , "7:00 pm","8:30 pm","11:30 pm"] , 
    Private  : ["2:30 pm","10:00 pm"] , 
    VIP :  ["1:00 pm" , "7:00 pm"]
    
 } , 
 {
  movieId:7 , 
  type:"2D", 
  Magnum:[] , 
  Private  : ["11:30 am","2:30 pm","2:30 pm","10:00 pm"] , 
  VIP :  ["11:30 am" , "7:00 pm","8:30 pm","11:30 pm"]


} , 
{
movieId:6 , 
type:"IMAX", 
Magnum:["11:30 am" , "1:00 pm","2:30 pm","5:30 pm"] , 
Private  : ["2:30 pm","10:00 pm"] , 
VIP :  ["11:30 am" ,"1:00 pm" ,"10:00 pm"]


} 
]



  constructor() { }
  setVideoSrc(src:string)
  {
    this.videoSrc = src ; 
  }
  setVideoDisplay(displayStatus:boolean)
  {
    this.videoDisplay = displayStatus ;
  }
  getVideoSrc()
  {
    return this.videoSrc ; 
  }
  getvideoDispaly()
  {
    return this.videoDisplay ;
  }
}
